import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

export const StandardProductImageContainer = styled.div`
  padding-bottom: ${SPACER.small};
  width: 218px;
  ${MEDIA_QUERIES.mdUp} {
    width: 273px;
  }
`;

export const EcomProductImageContainer = styled.div`
  padding-bottom: ${SPACER.small};
  width: 240px;
  margin: auto;

  ${MEDIA_QUERIES.mdUp} {
    width: 218px;
  }
`;

export const ImageTag = styled.div`
  position: absolute;
  padding: 1px 5px;
  background-color: #ff824f;
  font-weight: 700;
  z-index: 1;
  right: ${SPACER.medium};
  top: ${SPACER.medium};
`;
